<template>
    <div class="tab_content">
        <span class="tab_content-title">{{ $t('editorTabShapesTitle') }}</span>
        <div class="image_cells tab_grid">
            <div
                v-for="(shape, index) in shapes"
                :key="index"
                class="image_cells-item"
                @click="addElement(shape)"
            >
                <inline-svg
                    :alt="shape.name"
                    :src="shape.svg"
                    :fill="shape.isOutline ? 'none' : '#8F6E9F'"
                    :stroke="shape.isOutline ? '#8F6E9F' : 'none'"
                    width="60"
                    height="60"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { uuid } from 'vue-uuid';
    import { vuexHistory } from '../../../store/index';

    import across_shape from '../../../assets/shapes/across.svg';
    import arrow_down_shape from '../../../assets/shapes/arrow_down.svg';
    import arrow_left_shape from '../../../assets/shapes/arrow_left.svg';
    import arrow_right_shape from '../../../assets/shapes/arrow_right.svg';
    import arrow_up_shape from '../../../assets/shapes/arrow_up.svg';
    import car_shape from '../../../assets/shapes/car.svg';
    import card_shape from '../../../assets/shapes/card.svg';
    import circle_check_shape from '../../../assets/shapes/circle_check.svg';
    import circle_exclamation_shape from '../../../assets/shapes/circle_exclamation.svg';
    import circle_shape from '../../../assets/shapes/circle_opaque.svg';
    import ellipsis_shape from '../../../assets/shapes/ellipsis_opaque.svg';
    import hand_shape from '../../../assets/shapes/hand.svg';
    import heart_shape from '../../../assets/shapes/heart_opaque.svg';
    import heart_outline_shape from '../../../assets/shapes/heart_outlines.svg';
    import nfc_shape from '../../../assets/shapes/nfc.svg';
    import rectangle_shape from '../../../assets/shapes/rectangle_opaque.svg';
    import rectangle_outline_shape from '../../../assets/shapes/rectangle_outlines.svg';
    import smile_shape from '../../../assets/shapes/smile.svg';
    import square_shape from '../../../assets/shapes/square_opaque.svg';
    import square_outline_shape from '../../../assets/shapes/square_outlines.svg';
    import square_rounded_shape from '../../../assets/shapes/square_rounded_opaque.svg';
    import star_shape from '../../../assets/shapes/star_opaque.svg';
    import stripes_shape from '../../../assets/shapes/stripes.svg';
    import triangle_shape from '../../../assets/shapes/triangle_opaque.svg';
    import triangle_outline_shape from '../../../assets/shapes/triangle.svg';
    import triangle_exclamation_shape from '../../../assets/shapes/triangle_opaque_exclamation.svg';
    import user_shape from '../../../assets/shapes/user.svg';
    import wifi_shape from '../../../assets/shapes/wifi.svg';

    export default {
        data() {
            return {
                shapes: [
                    {
                        name: 'across',
                        svg: across_shape,
                        width: 54,
                        height: 54
                    },
                    {
                        name: 'arrow_down',
                        svg: arrow_down_shape,
                        width: 48,
                        height: 48
                    },
                    {
                        name: 'arrow_left',
                        svg: arrow_left_shape,
                        width: 48,
                        height: 48
                    },
                    {
                        name: 'arrow_right',
                        svg: arrow_right_shape,
                        width: 48,
                        height: 48
                    },
                    {
                        name: 'arrow_up',
                        svg: arrow_up_shape,
                        width: 48,
                        height: 48
                    },
                    {
                        name: 'car',
                        svg: car_shape,
                        width: 54,
                        height: 48
                    },
                    {
                        name: 'card',
                        svg: card_shape,
                        width: 60,
                        height: 48
                    },
                    {
                        name: 'circle_check',
                        svg: circle_check_shape,
                        width: 60,
                        height: 60
                    },
                    {
                        name: 'circle_exclamation',
                        svg: circle_exclamation_shape,
                        width: 60,
                        height: 60
                    },
                    {
                        name: 'circle',
                        svg: circle_shape,
                        width: 60,
                        height: 60
                    },
                    {
                        name: 'ellipsis',
                        svg: ellipsis_shape,
                        width: 27,
                        height: 54
                    },
                    {
                        name: 'hand',
                        svg: hand_shape,
                        width: 60,
                        height: 72
                    },
                    {
                        name: 'heart',
                        svg: heart_shape,
                        width: 60,
                        height: 54
                    },
                    {
                        name: 'heart_outline',
                        svg: heart_outline_shape,
                        width: 60,
                        height: 54
                    },
                    {
                        name: 'nfc',
                        svg: nfc_shape,
                        width: 48,
                        height: 60
                    },
                    {
                        name: 'rectangle',
                        svg: rectangle_shape,
                        width: 54,
                        height: 27
                    },
                    {
                        name: 'rectangle_outline',
                        svg: rectangle_outline_shape,
                        isOutline: true,
                        width: 54,
                        height: 27
                    },
                    {
                        name: 'smile',
                        svg: smile_shape,
                        width: 60,
                        height: 60
                    },
                    {
                        name: 'square',
                        svg: square_shape,
                        width: 54,
                        height: 54
                    },
                    {
                        name: 'square_outline',
                        svg: square_outline_shape,
                        isOutline: true,
                        width: 54,
                        height: 54
                    },
                    {
                        name: 'square_rounded',
                        svg: square_rounded_shape,
                        width: 54,
                        height: 54
                    },
                    {
                        name: 'star',
                        svg: star_shape,
                        width: 60,
                        height: 60
                    },
                    {
                        name: 'stripes',
                        svg: stripes_shape,
                        width: 54,
                        height: 54
                    },
                    {
                        name: 'triangle',
                        svg: triangle_shape,
                        width: 60,
                        height: 48
                    },
                    {
                        name: 'triangle_outline',
                        svg: triangle_outline_shape,
                        width: 60,
                        height: 48
                    },
                    {
                        name: 'triangle_exclamation',
                        svg: triangle_exclamation_shape,
                        width: 60,
                        height: 48
                    },
                    {
                        name: 'user',
                        svg: user_shape,
                        width: 48,
                        height: 48
                    },
                    {
                        name: 'wifi',
                        svg: wifi_shape,
                        width: 48,
                        height: 48
                    }
                ]
            }
        },
        methods: {
            addElement(shape) {
                let newShapeElement = {
                    id: uuid.v1(),
                    pageId: this.getActivePageId,
                    type: 'SHAPE_ELEMENT',
                    name: shape.name,
                    path: shape.svg,
                    isOutline: Object.keys(shape).includes('isOutline') ? true : false,
                    height: shape.height,
                    width: shape.width,
                    endValues: {
                        width: shape.width,
                        height: shape.height,
                    },
                    frame: {
                        translate: [0, 0],
                        scale: [1, 1],
                        rotate: 0
                    },
                    webSizeMM: {
                        width: shape.width * 0.084667,
                        height: shape.height * 0.084667,
                        translate: [0 * 0.084667, 0 * 0.084667]
                    },
                    isActive: true,
                    color: {
                        rgb: 'rgb(190, 186, 186)',
                        hex: 'BEBABA',
                        X: 4,
                        Y: 111
                    },
                    zIndex: this.getZIndex,
                    isLocked: false,
                    newTransforms: true
                }

                if (this.getSessionDetails.mode === 'user') {
                    if (this.getActivePage.content.isLocked === false) {
                        this.$store.dispatch('ADD_PAGE_ELEMENT', newShapeElement);
                        vuexHistory.saveSnapshot();
                    }
                } else {
                    this.$store.dispatch('ADD_PAGE_ELEMENT', newShapeElement);
                    vuexHistory.saveSnapshot();
                }
            }
        },
        computed: {
            ...mapGetters([
                'getZIndex',
                'getActivePageId',
                'getActivePage',
                'getSessionDetails'
            ])
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .image_cells-item {
        margin: 15px;
        cursor: pointer;
    }
    .tab_content {
        height: 100%;
    }
    .tab_grid {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        height: 96%;
        overflow-y: auto;
        overflow-x: hidden;
        margin-top: $pd-s;
    }
    // .tab_grid::-webkit-scrollbar-track {
    //     border-radius: 10px;
    //     background-color: #4f2862;
    // }
    // .tab_grid::-webkit-scrollbar {
    //     width: 10px;
    //     margin-right: 5px;
    // }
    // .tab_grid::-webkit-scrollbar-thumb {
    //     border-radius: 10px;
    //     background-color: #6c497c;
    // }
</style>